import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { getCache, setCache } from 'app/requests/cache';
import { buildParams } from 'app/utils/pagination';
import { serverRequest } from './serverRequest';
import { UserActivitie } from 'types/commons';
import { decrypt } from 'app/utils/crypto';
import { parse } from 'cookie';

export const getLanguages = async (code = 'vi') => {
  const paramsUrl = buildParams({ code });
  const result = await apiRequest(`/api/languages${paramsUrl}`, 'get') as ResultAPI;
  return result.data;
};

export const createUserActivity = async (data: UserActivitie) => {
  const cookies = parse(document.cookie || '');
  const token = cookies?.auth_token;

  await serverRequest('/api/user-activities/', 'post', token, data);
}

export const deleteUserActivity = async (data: UserActivitie) => {
  const cookies = parse(document.cookie || '');
  const token = cookies?.auth_token;

  await serverRequest(`/api/user-activities/${data.activity_type}/${data.activity_id}`, 'delete', token);
}

export const list = async (key: string, path = '', url?: string) => {
  try {
    // const cachedData = await getCache(key) as string;
    // if (cachedData) {
    //   const cacheDecrypt = await decrypt(cachedData);
    //   return JSON.parse(cacheDecrypt);
    // }

    const result = await apiRequest(path, 'get', {}, false, url) as ResultAPI;
    await setCache({ key, value: result});

    return result;
  } catch (error) {
    console.log(error)
    return null;
  }
};

